import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';
import { Button } from '../ui/button';

const TripPreview = ({ preview, onCommit }) => {
  const { legs, no_mileage_entries, totals, maps_url, trip_date } = preview;

  return (
    <Card>
      <CardHeader className="py-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base">Trip Preview - {trip_date}</CardTitle>
          <div className="flex gap-2">
            {maps_url && (
              <Button variant="outline" size="sm" onClick={() => window.open(maps_url, '_blank')}>
                View Maps
              </Button>
            )}
            <Button size="sm" onClick={onCommit}>
              Commit Trip
            </Button>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        {/* Trip Legs */}
        {legs.length > 0 && (
          <div>
            <h4 className="text-sm font-semibold mb-2">Trip Legs</h4>
            <div className="overflow-x-auto">
            <table className="w-full text-sm min-w-[640px]">
              <thead>
                <tr className="border-b text-left text-muted-foreground">
                  <th className="pb-1">Route</th>
                  <th className="pb-1">Distance</th>
                  <th className="pb-1">Billable</th>
                  <th className="pb-1">Unbillable</th>
                  <th className="pb-1">Cost</th>
                  <th className="pb-1">Description</th>
                </tr>
              </thead>
              <tbody>
                {legs.map((leg, i) => (
                  <tr key={i} className="border-b border-border/50">
                    <td className="py-1">{leg.from_id} &rarr; {leg.to_id}</td>
                    <td className="py-1">{leg.distance.toFixed(2)} mi</td>
                    <td className="py-1">{leg.billable_time > 0 ? `${leg.billable_time} hrs` : '-'}</td>
                    <td className="py-1">{leg.unbillable_time > 0 ? `${leg.unbillable_time} hrs` : '-'}</td>
                    <td className="py-1">{leg.cost > 0 ? `$${leg.cost.toFixed(2)}` : '-'}</td>
                    <td className="py-1 text-muted-foreground">{leg.description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          </div>
        )}

        {/* No Mileage Entries */}
        {no_mileage_entries.length > 0 && (
          <div>
            <h4 className="text-sm font-semibold mb-2">Supplemental Expenses (No Mileage)</h4>
            <div className="overflow-x-auto">
            <table className="w-full text-sm min-w-[560px]">
              <thead>
                <tr className="border-b text-left text-muted-foreground">
                  <th className="pb-1">Customer</th>
                  <th className="pb-1">Billable</th>
                  <th className="pb-1">Unbillable</th>
                  <th className="pb-1">Cost</th>
                  <th className="pb-1">Description</th>
                </tr>
              </thead>
              <tbody>
                {no_mileage_entries.map((entry, i) => (
                  <tr key={i} className="border-b border-border/50">
                    <td className="py-1">{entry.customer_id}</td>
                    <td className="py-1">{entry.billable_time > 0 ? `${entry.billable_time} hrs` : '-'}</td>
                    <td className="py-1">{entry.unbillable_time > 0 ? `${entry.unbillable_time} hrs` : '-'}</td>
                    <td className="py-1">{entry.cost > 0 ? `$${entry.cost.toFixed(2)}` : '-'}</td>
                    <td className="py-1 text-muted-foreground">{entry.description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          </div>
        )}

        {/* Totals */}
        <div className="border-t pt-3 space-y-1 text-sm font-semibold">
          {totals.distance > 0 && <div>Total Distance: {totals.distance.toFixed(2)} miles</div>}
          <div>Total Time: {(totals.billable_time + totals.unbillable_time).toFixed(1)} hours
            {totals.billable_time > 0 && ` (${totals.billable_time} billable`}
            {totals.unbillable_time > 0 && ` + ${totals.unbillable_time} unbillable`}
            {(totals.billable_time > 0 || totals.unbillable_time > 0) && ')'}
          </div>
          <div>Total Cost: ${totals.cost.toFixed(2)}</div>
        </div>
      </CardContent>
    </Card>
  );
};

export default TripPreview;
